module.exports = __webpack_public_path__ + "img/image15.7d65f548.jpg";